import actionTypes from 'constants/checkoutDataConstants';
import { fetchPublishers } from './publishersActions';
import { fetchBasicUserData } from './currentUserActions';
import { showAppGlobalInfo } from './appActions';
import { setupAuthorizationToken, authorizedUrl } from 'lib/auth';
import { clearState } from 'lib/formStorage';
import { trackEvent } from 'lib/eventTracking';
import get from 'lodash/get';
const MAX_IMAGE_POLLING_COUNTS = 4;
const IMAGE_POLLING_TIME = 3000;

export function updatePackagePrice() {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.FETCH_PRICE_REQUEST });
    const { config, checkoutData } = getState();
    let update_price_endpoint = '';
    update_price_endpoint = priceEndpoint(checkoutData);
    api.get(update_price_endpoint, { params: buildPackageParams(checkoutData, config) }).then(
      response => dispatch({ type: actionTypes.FETCH_PRICE_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_PRICE_FAILURE, payload: error })
    );
  };
}

export function getSnapSellPrices(singleQuantity = 1, subscriptionQuantity = 4) {
  return (dispatch, getState, api) => {
    const { config, checkoutData } = getState();
    const packageParams = buildPackageParams(checkoutData, config);
    const price_endpoint = '/packages/pricing';

    fetchSinglePrice(dispatch, getState, api, price_endpoint, packageParams, singleQuantity);
    fetchSubscriptionPrice(dispatch, getState, api, price_endpoint, packageParams, subscriptionQuantity);
  };
}

export function getSnapsellSinglePrice(quantity){
  return (dispatch, getState, api) => {
    const { config, checkoutData } = getState();
    const packageParams = buildPackageParams(checkoutData, config);
    const price_endpoint = '/packages/pricing';

    fetchSinglePrice(dispatch, getState, api, price_endpoint, packageParams, quantity);
  };
}

export function getSnapsellSubscriptionPrice(quantity){
  return (dispatch, getState, api) => {
    const { config, checkoutData } = getState();
    const packageParams = buildPackageParams(checkoutData, config);
    const price_endpoint = '/packages/pricing';

    fetchSubscriptionPrice(dispatch, getState, api, price_endpoint, packageParams, quantity);
  };
}

function fetchSinglePrice(dispatch, getState, api, price_endpoint, packageParams, singleQuantity){
  dispatch({ type: actionTypes.FETCH_SINGLE_PRICE_REQUEST });
  api.get(price_endpoint,
    { params: {
      ...packageParams,
      package_type: 'single',
      event_quantity: singleQuantity,
    }})
    .then(
      response => dispatch({ type: actionTypes.FETCH_SINGLE_PRICE_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_SINGLE_PRICE_FAILURE, payload: error })
    );
}

function fetchSubscriptionPrice(dispatch, getState, api, price_endpoint, packageParams, subscriptionQuantity){
  dispatch({ type: actionTypes.FETCH_SUBSCRIPTION_PRICE_REQUEST });
  api.get(price_endpoint,
    { params: {
      ...packageParams,
      package_type: 'subscription',
      event_quantity: subscriptionQuantity,
    }})
    .then(
      response => dispatch({ type: actionTypes.FETCH_SUBSCRIPTION_PRICE_SUCCESS, payload: response.data }),
      error => dispatch({ type: actionTypes.FETCH_SUBSCRIPTION_PRICE_FAILURE, payload: error })
    );
}

export const changeIsUpgrading = (isUpgrading) => dispatch => {
  dispatch({ type: actionTypes.IS_UPGRADING_CHANGED, is_upgrading: isUpgrading });
};

export const updatePrintEligible = () => dispatch => {
  dispatch({ type: actionTypes.PRINT_ELIGIBILITY_TOGGLED });
};

function priceEndpoint(checkoutData) {
  if (checkoutData.get('invoice_id') !== null) { return '/invoices/pricing'; }
  if (checkoutData.get('email_campaign_id') !== null) { return '/email_campaigns/pricing'; }
  if (checkoutData.get('publisher_id') !== null) { return '/publishers/pricing'; }
  return '/packages/pricing';
}

function orderEndpoint(checkoutData) {
  if (checkoutData.get('invoice_id') !== null) { return '/invoices/checkout'; }
  if (checkoutData.get('email_campaign_id') !== null) { return '/email_campaigns/checkout'; }
  if (checkoutData.get('publisher_id') !== null) { return '/publishers/checkout'; }
  return '/packages/checkout';
}

export function buildPackageParams(checkoutData, config, form, isSnapSell) {
  const params = {};
  if (checkoutData.get('email_campaign_id') !== null) {
    params['email_campaign_id'] = checkoutData.get('email_campaign_id');
    params['currency'] = checkoutData.get('currency');
  } else if (checkoutData.get('invoice_id') !== null) {
    params['invoice_id'] = checkoutData.get('invoice_id');
    params['currency'] = checkoutData.get('currency');
  } else if (checkoutData.get('publisher_id') !== null) {
    params['publisher_id'] = checkoutData.get('publisher_id');
    params['currency'] = checkoutData.get('currency');
    params['package_type'] = checkoutData.get('package_type');
  } else {
    params['market'] = checkoutData.get('market');
    params['event_quantity'] = checkoutData.get('event_quantity');
    params['package_type'] = checkoutData.get('package_type');
    params['currency'] = checkoutData.get('currency');
  }

  if (config && config.get('partner_api_key')) {
    params['partner_api_key'] = config.get('partner_api_key');
  }
  if (checkoutData.get('is_upgrading', false)) {
    params['event_id'] = checkoutData.getIn(['current_event', 'id'], null);
  } else {
    params['market'] = checkoutData.get('market');
    if (checkoutData.get('package_id')) {
      params['package_id'] = checkoutData.get('package_id');
    }
  }

  if (isSnapSell) {
    params['email'] = get(form, 'eventSubmission.values.email', '');
    params['sell_source'] = 'SnapSell';
  } else if (params['event_id'] || params['email_campaign_id']) {
    params['sell_source'] = 'Checkout';
  } else if (checkoutData.get('package_id') && !checkoutData.get('prepay')) {
    params['sell_source'] = 'Rebooking';
  } else {
    params['package_id'] = checkoutData.get('package_id');
    params['prepay'] = true;
    params['sell_source'] = 'Package';
  }

  if (checkoutData.get('business')  !== null ) {
    params['business'] = checkoutData.get('business');
  }

  if (checkoutData.get('print_eligible')  !== null ) {
    params['print_eligible'] = checkoutData.get('print_eligible');
  }

  return params;
}

function updateOption(actionType, value, doUpdate = true) {
  return (dispatch) => {
    dispatch({ type: actionType, payload: value });
    if (doUpdate) {
      dispatch(updatePackagePrice());
    }
  };
}

export function changePackageType(newType) {
  return (dispatch, getState) => {
    if (newType === 'free' || newType === 'single') {
      dispatch(updateOption(actionTypes.PACKAGE_EVENT_QUANTITY_CHANGED, 1, false));
    }
    if (newType === 'subscription' && getState().checkoutData.get('event_quantity', 1) < 4) {
      dispatch(updateOption(actionTypes.PACKAGE_EVENT_QUANTITY_CHANGED, 4, false));
    }
    dispatch(updateOption(actionTypes.PACKAGE_TYPE_CHANGED, newType));
    dispatch(fetchPublishers());
  };
}

export function changePackageEventQuantity(newValue) {
  return (dispatch) => {
    dispatch(updateOption(actionTypes.PACKAGE_EVENT_QUANTITY_CHANGED, newValue));
  };
}

export function changePackageCurrency(newCurrency) {
  return (dispatch) => {
    dispatch(updateOption(actionTypes.PACKAGE_CURRENCY_CHANGED, newCurrency));
  };
}

function createBackendOrder(history, formData, paymentIntentData, isSnapSell = false, stripeApi) {
  return (dispatch, getState, api) => {
    const { config, checkoutData, form } = getState();
    dispatch({ type: actionTypes.CREATE_ORDER_REQUEST });
    const params = {
      payment_method_id: paymentIntentData.payment_method_id,
      payment_intent_id: paymentIntentData.payment_intent_id,
      ...buildPackageParams(checkoutData, config, form, isSnapSell),
      ...formData
    };

    const currentEventId = checkoutData.getIn(['current_event', 'id'], null);
    const isUpgrading = checkoutData.get('is_upgrading');
    if (currentEventId && isUpgrading) { params['event_id'] = currentEventId; }
    let order_endpoint = '';
    order_endpoint = orderEndpoint(checkoutData);
    api.post(order_endpoint, params).then(
      response => {
        if (response.data && response.data.requires_action)
          dispatch(handleRequiresAction(response.data, history, formData, isSnapSell,stripeApi));
        else
          dispatch(orderCreatedSuccessfully(history, response.data, isSnapSell));
      },
      result => dispatch({ type: actionTypes.CREATE_ORDER_FAILURE, payload: result.response.data.error })
    );
  };
}

function handleRequiresAction(paymentIntentData, history, formData, isSnapSell,stripeApi) {
  return (dispatch, getState) => {
    stripeApi.handleCardAction(
      paymentIntentData.payment_intent_client_secret
    ).then(function (result) {
      if (result.error) {
        dispatch({type: actionTypes.CREATE_ORDER_FAILURE, payload: result.error});
      } else {
        dispatch(createBackendOrder(history, formData, paymentIntentData, isSnapSell, stripeApi));
      }
    });
  };
}

function handleStripeResult(formData, result, history, isSnapSell = false, stripeApi) {
  return (dispatch) => {
    if (result.error) {
      dispatch({type: actionTypes.CREATE_STRIPE_CARD_FAILURE, payload: result.error});
    } else{
      dispatch({ type: actionTypes.CREATE_STRIPE_CARD_SUCCESS });
      const paymentIntentData = { payment_method_id: result.paymentMethod.id };
      dispatch(createBackendOrder(history, formData, paymentIntentData , isSnapSell, stripeApi));
    }
  };
}

function handleStripeError(error) {
  return (dispatch) => {
    if (error.message.indexOf('address_country') > -1) {
      dispatch({ type: actionTypes.CREATE_ORDER_FAILURE, payload: { details: { country: 'is missing' } }});
    }
  };
}

function orderCreatedSuccessfully(history, payload, isSnapSell) {
  return (dispatch, getState) => {
    if (payload && payload.package_id) {
      dispatch(notifyGTM(payload));
    }
    if (isSnapSell) {
      setupAuthorizationToken(payload.current_user.token);
      dispatch(fetchBasicUserData());
      dispatch({ type: actionTypes.CREATE_ORDER_SUCCESS, payload: false });
      dispatch({ type: actionTypes.SET_SNAP_SELL_PACKAGE_ID, payload: payload.package_id });
      reportPurchaseData(getState().checkoutData, true,function () {
        history.push('/basics');
      });
      dispatch(showAppGlobalInfo('Congratulations, you have purchased a package!'));
    } else {
      clearState();

      const afterSuccessPath = getState().checkoutData.get('on_success_redirect_to');
      if (afterSuccessPath) {
        reportPurchaseData(getState().checkoutData, false,function () {
          window.location = authorizedUrl(afterSuccessPath);
        });

        dispatch({ type: actionTypes.CREATE_ORDER_SUCCESS, payload: true });
      } else {
        dispatch({ type: actionTypes.CREATE_ORDER_SUCCESS, payload: false });
      }
    }
  };
}

function reportPurchaseData(checkoutData, is_snapsell = false, callback){
  let params;
  if (checkoutData.get('credits_left') > 0 && checkoutData.get('is_upgrading')){
    params = {
      package_type: 'upgrade',
      upgrading: true,
      price: 0,
      assigned_credit: true,
      is_snapsell_checkout: is_snapsell
    };
  }
  else{
    params = {
      package_type: checkoutData.get('package_type'),
      price: checkoutData.get('currentPrice'),
      quantity: checkoutData.get('quantity'),
      assigned_credit: false,
      is_snapsell_checkout: is_snapsell
    };
  }

  trackEvent('Completed Checkout', params, callback);
}

export function createOrder(formData, stripeApi, stripeElement, history, isSnapSell = false) {
  return (dispatch) => {
    if (formData.payment_method === 'card') {
      dispatch({ type: actionTypes.CREATE_STRIPE_CARD_REQUEST });
      stripeApi.createPaymentMethod(formData.payment_method , stripeElement, {
        billing_details:{
          name: formData.name,
          address: {
            line1: formData.address1,
            line2: formData.address2,
            city: formData.city,
            postal_code: formData.zip_code,
            country: formData.country ? formData.country.iso_alpha2 : null
          }
        }
      }).then(
        (result) => dispatch(handleStripeResult(formData, result, history, isSnapSell, stripeApi)),
        (error) => dispatch(handleStripeError(error)),
      );
    } else {
      dispatch(createBackendOrder(history, formData));
    }
  };
}

export function createSimpleOrder(type = 'free') {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.CREATE_ORDER_REQUEST });
    const { config, checkoutData } = getState();
    const params = buildPackageParams(checkoutData, config);
    const currentEventId = checkoutData.getIn(['current_event', 'id'], null);
    const prefix = checkoutData.get('publisher_id') !== null ? '/publishers/checkout' : '/packages/checkout';
    if (currentEventId) { params['event_id'] = currentEventId; }
    api.post(`${prefix}_${type}`, params).then(
      response => {
        if (response.data && response.data.requires_action)
          dispatch(handleRequiresAction(response.data));
        else
          dispatch(orderCreatedSuccessfully(response.data));
      },
      result => dispatch({ type: actionTypes.CREATE_ORDER_FAILURE, payload: result.response.data.error })
    );
  };
}

function handleImagePollingResponse(data, pollingStatus) {
  return (dispatch) => {
    if (data.image_url !== null) {
      dispatch({ type: actionTypes.FETCH_EVENT_IMAGE_SUCCESS, payload: data });
    } else {
      if (pollingStatus.get('tries', 0) < MAX_IMAGE_POLLING_COUNTS) {
        setTimeout(() => dispatch(startEventImagePolling()), IMAGE_POLLING_TIME);
      } else {
        dispatch({ type: actionTypes.FETCH_EVENT_IMAGE_FAILURE });
      }
    }
  };
}

export function startEventImagePolling() {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.FETCH_EVENT_IMAGE_REQUEST });
    const currentPollingStatus = getState().checkoutData.get('eventImagePolling');
    const currentEventId = getState().checkoutData.getIn(['current_event', 'id'], null);

    api.get(`/events/${currentEventId}`).then(
      response => dispatch(handleImagePollingResponse(response.data, currentPollingStatus))
    );
  };
}

export const notifyGTM = (payload) => (dispatch, getState) => {
  if (!window.gtag || !window.dataLayer) {
    return;
  }
  const currentState = getState();
  const { checkoutData } = currentState;
  const currency = checkoutData.get('currency');

  window.gtag('event', 'purchase', {
    'transaction_id': payload.package_id,
    'affiliation': currentState.config.get('partner_api_key', ''),
    'value': checkoutData.get('currentPrice', 0),
    'tax': payload.vat,
    'currency': currency,
    'shipping': 0,
    'items': [
      {
        'id': checkoutData.get('market'),
        'name': checkoutData.get('package_type'),
        'category': checkoutData.getIn(['current_event', 'category_id'], ''),
        'price': checkoutData.get('currentPrice', 0),
        'quantity': checkoutData.get('event_quantity', 0),
        'currency': currency
      }
    ]
  });

  // window.dataLayer.push({
  //   'event': 'purchase',
  //   'eCommerce': {
  //     'purchase': {
  //       'transaction_id': payload.package_id,
  //       'affiliation': currentState.config.get('partner_api_key', ''),
  //       'value': checkoutData.get('currentPrice', 0),
  //       'tax': payload.vat,
  //       'currency': currency,
  //       'items': [
  //         {
  //           'item_name': checkoutData.get('package_type'),
  //           'item_price': checkoutData.get('currentPrice', 0),
  //           'item_category': checkoutData.getIn(['current_event', 'category_id'], ''),
  //           'quantity': checkoutData.get('event_quantity', 0)
  //         }
  //       ]
  //     }
  //   }
  // });
  
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/checkoutDataActions.js